import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../redux/issuesV2';
import ModalViewRelationships from '../../projects/dependencies/ModalViewRelationships';
import { useIssueDetailsModals } from '../IssueDetails/IssueDetailsModalsContext';

/**
 * ViewPathModal is a wrapper around the existing ModalViewRelationships component,
 * which is also displayed in the Dependencies page.
 */
const ViewPathModal: VoidFunctionComponent = () => {
  const packageTitle = useSelector(IssuesV2Store.selectors.getIssuePackageTitle);
  const packageRevisionLocator = useSelector(IssuesV2Store.selectors.getIssuePackageRevisionLocator);

  const { viewPathModal } = useIssueDetailsModals();

  const revision = useMemo(() => ({
    locator: packageRevisionLocator,
    project: {
      title: packageTitle,
    },
  }), [packageRevisionLocator, packageTitle]);

  return (
    <ModalViewRelationships
      show={viewPathModal.isOpen}
      onHide={viewPathModal.onClose}
      parentLocator={viewPathModal.projectLocator as string}
      revision={revision}
    />
  );
};

export default ViewPathModal;
